import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { fromEvent, Subject, takeUntil } from 'rxjs';
import { AppLookup } from 'src/app/models/lookup.model';
import { ConfigurationFilter, ProductConfiguration } from '../../../models/fitting-query-params.model';

@Component({
  selector: 'app-product-configurations',
  templateUrl: './product-configurations.component.html',
  styleUrls: ['./product-configurations.component.scss']
})
export class ProductConfigurationsComponent implements AfterViewInit, OnDestroy {
  @Input() configurationFilter?: ConfigurationFilter | null;
  @Input() configurations: ProductConfiguration[] = [];
  @Input() partNumber: string = '';
  @Input() referrer = '';
  @Input() defaultDescription = '';
  @Input() configurationsWithoutFilter: ProductConfiguration[] = [];
  @Input() configurationFilterIsApplied?: boolean;

  @Input() tappedHoleOptions: AppLookup[] = [];
  @Input() oringOptions: AppLookup[] = [];
  @Input() bevelOptions: AppLookup[] = [];

  @Output() magInspectionChanged = new EventEmitter<boolean>();
  @Output() buyAmericaChanged = new EventEmitter<boolean>();
  @Output() liftingLugsChanged = new EventEmitter<boolean>();
  @Output() tappedBlindChanged = new EventEmitter<{ value: string, status: boolean }>(); // i.e. [3/4in, 1in],
  @Output() oringChanged = new EventEmitter<{ value: string, status: boolean }>();
  @Output() bevelChanged = new EventEmitter<{ value: string, status: boolean }>();

  @ViewChild('liftingLugs') liftingLugs?: ElementRef<HTMLInputElement>;
  @ViewChild('magInspection') magInspection?: ElementRef<HTMLInputElement>;
  @ViewChild('buyAmerica') buyAmerica?: ElementRef<HTMLInputElement>;

  unsubscribe$ = new Subject();

  constructor() { }
  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
  }

  ngAfterViewInit(): void {
    if (!!this.configurationFilter) {
      if (this.magInspection?.nativeElement) this.magInspection.nativeElement.checked = Boolean(this.configurationFilter.magInspection);
      if (this.liftingLugs?.nativeElement) this.liftingLugs.nativeElement.checked = Boolean(this.configurationFilter.liftingLugs);
      if (this.buyAmerica?.nativeElement) this.buyAmerica.nativeElement.checked = Boolean(this.configurationFilter.buyAmerica);
    }

    if (this.liftingLugs) fromEvent(this.liftingLugs.nativeElement, 'change').pipe(takeUntil(this.unsubscribe$)).subscribe((val: any) => this.liftingLugsChanged.emit(val.target.checked));
    if (this.magInspection) fromEvent(this.magInspection.nativeElement, 'change').pipe(takeUntil(this.unsubscribe$)).subscribe((val: any) => this.magInspectionChanged.emit(val.target.checked));
    if (this.buyAmerica) fromEvent(this.buyAmerica.nativeElement, 'change').pipe(takeUntil(this.unsubscribe$)).subscribe((val: any) => this.buyAmericaChanged.emit(val.target.checked));
  }

  dispatchTappedHolesChange(obj: { value: string, status: any }) {
    this.tappedBlindChanged.emit({ value: obj.value, status: obj.status.target.checked });
  }

  dispatchOringChange(obj: { value: string, status: any }) {
    this.oringChanged.emit({ value: obj.value, status: obj.status.target.checked });
  }

  dispatchBevelChange(obj: { value: string, status: any }) {
    this.bevelChanged.emit({ value: obj.value, status: obj.status.target.checked });
  }
}

